import types from './types';

const receiveOmniBrandsFollowing = (brands: any) => ({
  type: types.RECEIVE_ALL_OMNI_BRANDS_FOLLOWING,
  brands
});

export default { receiveOmniBrandsFollowing };
